import { Dispatch, SetStateAction, useState } from 'react'
import { logSentryErrorAndGetTraceId } from '@node-space/utils'
import { BaseErrorResponse } from 'types/errors'

export type MappedErrorMessageState = {
  errorCode?: number
  errorType?: string
  handledMessage?: React.ReactNode
  sentryTraceId?: string
  show: boolean
}

export type HandleRequestErrorFn = (error: BaseErrorResponse, errorLabel: string) => void

export type MappedErrorMessageReturn = {
  initialRequestError: MappedErrorMessageState
  requestError: MappedErrorMessageState
  setRequestError: Dispatch<SetStateAction<MappedErrorMessageState>>
  resetRequestError: () => void
  handleRequestError: HandleRequestErrorFn
}

export const useMappedErrorMessage = (): MappedErrorMessageReturn => {
  const initialRequestError: MappedErrorMessageState = {
    show: false,
  }

  const [requestError, setRequestError] = useState<MappedErrorMessageState>(initialRequestError)

  const resetRequestError = () => setRequestError(initialRequestError)

  const handleRequestError: HandleRequestErrorFn = (error, errorLabel) => {
    const sentryTraceId = logSentryErrorAndGetTraceId(errorLabel, error)
    setRequestError({
      errorCode: error?.status,
      sentryTraceId,
      show: true,
    })
  }

  return {
    initialRequestError,
    requestError,
    setRequestError,
    resetRequestError,
    handleRequestError,
  }
}
